import type { SchemaBuilderFieldEditorContentProps } from "./schema-builder-field-editor-content.type";
import type { EditorSelectFormValues } from "../schema-builder-field-editor-select";

import { EditorDefaultFields } from "../schema-builder-field-editor-default";
import { EditorExpressionFields } from "../schema-builder-field-editor-expression";
import { EditorLabelFields } from "../schema-builder-field-editor-label";
import { EditorNumberFields } from "../schema-builder-field-editor-number";
import { EditorSelectFields } from "../schema-builder-field-editor-select";
import { EditorTextareaFields } from "../schema-builder-field-editor-textarea";
import { isSchemaFieldEditable } from "../schema-builder-field-editor.helper";

export const SchemaBuilderFieldEditorContent = ({
  schema,
  fieldType,
  initialValues,
}: SchemaBuilderFieldEditorContentProps) => {
  const isEditable = isSchemaFieldEditable(schema);

  // TODO IMP-1494 let user edit `label` and `placeholder` for severity section fields
  if (!isEditable) return <EditorDefaultFields disabled />;

  if (fieldType === "label") return <EditorLabelFields />;

  if (fieldType === "number") return <EditorNumberFields />;

  if (fieldType === "textArea") return <EditorTextareaFields />;

  if (fieldType === "select") {
    return (
      <EditorSelectFields
        initialValues={initialValues as EditorSelectFormValues}
      />
    );
  }

  if (fieldType === "expression") return <EditorExpressionFields />;

  return <EditorDefaultFields />;
};
